module.exports = __webpack_public_path__ + "static/media/01_MINS-2.0-S-14 1.d1c1bdeb.svg";